module.exports = __webpack_public_path__ + "static/media/fishin-reels.6717867f.gif";